import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, InternalAxiosRequestConfig } from 'axios'

interface CustomConstructParam {
    timeout?: number
}

class CustomAxios {
    private _axiosInstance: AxiosInstance

    constructor( { timeout = 120000 }: CustomConstructParam = {} ) {
        this._axiosInstance = axios.create( {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            },
            timeout
        } )

        this.setInterceptors()
    }

    private setInterceptors () {
        this._axiosInstance.interceptors.request.use(
            function ( config: InternalAxiosRequestConfig ) {
                return config
            },
            function ( error: AxiosError ) {
                return Promise.reject( error )
            }
        )

        this._axiosInstance.interceptors.response.use(
            function ( response: AxiosResponse ) {
                return response.data
            },
            function ( error: AxiosError<any, any> ) {
                const { response, config: originalRequest } = error
                if ( response ) {
                    const { data, headers, status } = response
                    if( status === 401 ) {
                        return Promise.reject( { status, originalRequest } )
                    } else {
                        if ( headers && headers[ 'x-error-code' ] ) {
                            data.message += `[${headers[ 'x-error-code' ]}]`
                        }
                        if ( data.unknown ) {
                            return new Promise( () => { /* */ } )
                        }
                        return Promise.reject( { data } )
                    }
                }
                return Promise.reject( {
                    message: '인터넷 연결을 확인해주세요.'
                } )
            }
        )
    }

    getAxios (): AxiosInstance {
        return this._axiosInstance
    }

    multipart<T> ( url: string, form: FormData, config: AxiosRequestConfig = {} ): Promise<ResponseVo<T>> {
        const { post } = this._axiosInstance
        return post( url, form, {
            ...config,
            headers: {
                'Content-Type': 'multipart/form-data',
                ...config.headers
            }
        } )
    }

    post<T> ( url: string, data: Record<string, any>, config: AxiosRequestConfig = {} ): Promise<ResponseVo<T>> {
        const { post } = this._axiosInstance
        return post( url, data, config )
    }

    get<T> ( url: string, config = {} ): Promise<ResponseVo<T>> {
        const { get } = this._axiosInstance
        return get( url, config )
    }
}


export default new CustomAxios()